module.exports = function(number, increment) {
    return (parseInt(number) + parseInt(increment));
};
